import { render } from "./AdminDeletionGateSection.vue?vue&type=template&id=f0a389d4&scoped=true"
import script from "./AdminDeletionGateSection.vue?vue&type=script&lang=js"
export * from "./AdminDeletionGateSection.vue?vue&type=script&lang=js"

import "./AdminDeletionGateSection.vue?vue&type=style&index=0&id=f0a389d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0a389d4"]])

export default __exports__